export default `
mutation WebHoldSubscription($input: HoldSubscriptionInput!) {
  HoldSubscription(input: $input) {
      subscription{
        billing_date
        hold_date
        id
        is_cancelled
        is_hold_pending
        on_hold
        promo_code
        status
        next_tote_status {
          message
          code
          final_code
          can_create_tote
        }
        subscription_type {
          id
          interval
          internal_name
          display_name_v2
          clothing_count
          accessory_count
          base_price
          is_accessory_slot_giveaway
          auto_renew_price_per_month
          preview {
            auto_renew_discount
            cash_price
            final_price
            name
            expiration_date_tips
            promo_code_price
          }
          free_service_type {
            id
            name
            clothing_count
            free_service_type_config {
              popup_content {
                img_url
              }
            }
          }
        }
      }
      errors
    }
  }
`
